import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FilterService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { CountriesService } from '../countries.service';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-countries-list',
  templateUrl: './countries-list.component.html',
  styleUrls: ['./countries-list.component.scss'],
  providers: []
})
export class CountriesListComponent implements OnInit {

  @ViewChild("grid") public grid:Table;
  public countriesFilters:any = {};
  public countries:any[];
  public totalRecords:number;
  public loading:boolean = false;
  private lastGridEvent:any;

  public first;
  public last;
  constructor(private countriesService:CountriesService,    
    private router:Router,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService,
    private translateService: TranslateService
    ) { }

  ngOnInit(): void {
  }

  search(){
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  clearFilters(){
    this.countriesFilters = {};
    this.search();
  }

  loadData($event){
    this.lastGridEvent = $event;
    Promise.resolve(null).then(() => this.loading = true);
    var params = {
      _page: $event.first,
      _pageSize: $event.rows,
      _sortBy: $event.sortField?$event.sortField:"",
      _sortDirection: $event.sortOrder>0?"asc":"desc"
    };
    params = Object.assign(params, this.countriesFilters);
    this.countriesService.all(params).subscribe({
      next: (data: any) => {
        this.totalRecords = data.totalRows;
        this.countries = data.rows;
        Promise.resolve(null).then(() => this.loading = false);
      },
      error: (error: any) => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        Promise.resolve(null).then(() => this.loading = false);
      }
    });
  }

  edit(country){
    this.router.navigate(['/configuration/countries/', country.id ]);
  }

  delete(country){
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.country.delete_message", { name: country.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.countriesService.delete(country.id).subscribe({
          next: (data: any) => {
            this.loadData(this.lastGridEvent);
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        });
      },
      reject: () => {
        
      }
    });
  }
}
